import formatcoords from 'formatcoords';
import parseCoords from "../../coordinates/parse-coords";
const LAT_LON_SEPARATOR = '/';
const DECIMAL_MINUTES_FRACTION_DIGITS = 6;
function isValid({ lat, lng }, position) {
    if (position.latitude && parseInt(position.latitude.degrees) + 1 <= lat) {
        return false;
    }
    if (position.longitude && parseInt(position.longitude.degrees) + 1 <= lng) {
        return false;
    }
    return -90 <= lat && lat <= 90 && -180 <= lng && lng <= 180;
}
function positionToString(position) {
    if (position.latitude && position.longitude) {
        const latString = coordinateToString(position.latitude).replace(/\s/g, '');
        const lonString = coordinateToString(position.longitude).replace(/\s/g, '');
        const pos = `${latString}, ${lonString}`;
        const parsedPos = parseCoords(pos);
        if (parsedPos && isValid(parsedPos, position)) {
            return `${parsedPos.lat.toFixed(DECIMAL_MINUTES_FRACTION_DIGITS)}${LAT_LON_SEPARATOR}${parsedPos.lng.toFixed(DECIMAL_MINUTES_FRACTION_DIGITS)}`;
        }
        return false;
    }
    else if (position.latitude || position.longitude) {
        return false;
    }
    return undefined;
}
function stringToPosition(pos) {
    if (pos) {
        const formattedPos = format(pos);
        const [posLat, posLon] = formattedPos.split(LAT_LON_SEPARATOR);
        return { latitude: posLat, longitude: posLon };
    }
    return { latitude: '', longitude: '' };
}
function parseCoordinates(pos) {
    if (!pos) {
        return {
            latitude: null,
            longitude: null,
        };
    }
    const formatOptions = {
        latLonSeparator: LAT_LON_SEPARATOR,
        decimalPlaces: 3,
    };
    const coord = formatcoords(pos.split(LAT_LON_SEPARATOR));
    const [degreesLat, degreesLon] = coord.format('D', formatOptions).split(LAT_LON_SEPARATOR);
    const minutes = coord.format('m', formatOptions).split(LAT_LON_SEPARATOR);
    const [minutesLat, minutesLon] = minutes.map((minute) => minute.split('.')[0]);
    const [secondsLat, secondsLon] = minutes.map((minute) => minute.split('.')[1]);
    const [directionLat, directionLon] = coord.format('X', formatOptions).split(LAT_LON_SEPARATOR);
    return {
        latitude: {
            degrees: degreesLat,
            minutes: minutesLat,
            seconds: secondsLat,
            direction: directionLat,
        },
        longitude: {
            degrees: degreesLon,
            minutes: minutesLon,
            seconds: secondsLon,
            direction: directionLon,
        },
    };
}
function coordinateToString(coordinate) {
    if (!coordinate) {
        return '';
    }
    return `${coordinate.degrees}°${coordinate.minutes}.${coordinate.seconds}'${coordinate.direction}`;
}
function formatNumber(number, length, succeeding = false) {
    const zeros = Array.from({ length }, () => '0').join('');
    if (!succeeding) {
        return `${zeros}${number}`.substr(-length);
    }
    return `${number}${zeros}`.substr(0, length);
}
function format(position) {
    const { latitude, longitude } = parseCoordinates(position);
    const latitudeString = !latitude
        ? ''
        : `${formatNumber(latitude.degrees, 2)}°${formatNumber(latitude.minutes, 2)}.${formatNumber(latitude.seconds, 3, true)}'${latitude.direction}`;
    const longitudeString = !longitude
        ? ''
        : `${formatNumber(longitude.degrees, 3)}°${formatNumber(longitude.minutes, 2)}.${formatNumber(longitude.seconds, 3, true)}'${longitude.direction}`;
    return `${latitudeString}${LAT_LON_SEPARATOR}${longitudeString}`;
}
export default {
    positionToString,
    stringToPosition,
    parseCoordinates,
    coordinateToString,
    format,
};
//# sourceMappingURL=PositionTransformer.js.map